<template>
  <a-menu
    v-model="currentSettings"
    mode="horizontal"
    :style="{
        background: 'transparent'
    }"
  >
    <a-menu-item 
        key="tags-settings"
    >
        <a-icon type="tags" />Címkék beállítása
    </a-menu-item>
    <a-menu-item 
        key="user-settings"
    >
        <a-icon type="team" />Felhasználók beállítása
    </a-menu-item>
  </a-menu>
</template>

<script>
export default {
    data() {
        return {
        }
    },
    computed: {
        currentSettings: {
            get() {
                return [this.$route.name]
            },
            set(val) {
                this.$router.push({
                    name: val[0]
                })
            }
        }
    }
}
</script>

<style lang="scss" scoped>

</style>